import { ZodiacWheel, Constellation } from '../CelestialPatterns'
import { useNavigate } from 'react-router-dom'

const STATS = [
  { value: '3', label: 'Reading Methods' },
  { value: '1', label: 'AI Assistant' },
  { value: '24/7', label: 'Available' },
  { value: '<60s', label: 'Average Reading' },
]

const HeroPanel = () => {
  const navigate = useNavigate()
  return (
    <section
      className="w-screen h-screen flex-shrink-0 relative overflow-hidden"
      style={{ background: '#CBB191' }}
    >
      <div className="grain-overlay" />

      <div className="absolute -top-16 -left-16 pointer-events-none">
        <ZodiacWheel size={380} />
      </div>
      <div className="absolute -bottom-20 -right-20 pointer-events-none">
        <Constellation />
      </div>

      <div className="relative z-10 flex flex-col h-full px-5 sm:px-8 lg:px-[5%] xl:px-[7%] pt-[80px] sm:pt-[84px] lg:pt-[88px] pb-5 sm:pb-6 lg:pb-8 overflow-y-auto lg:overflow-hidden">

        <div className="flex-1 flex flex-col lg:flex-row gap-5 sm:gap-6 lg:gap-0 items-start min-h-0">

          <div className="w-full lg:w-[50%] xl:w-[48%] flex flex-col justify-center lg:pr-8 xl:pr-16 min-h-0">

            <div className="mb-3 sm:mb-5 flex-shrink-0">
              <span
                className="font-mono uppercase tracking-[0.3em]"
                style={{ fontSize: 'clamp(7px, 0.7vw, 9px)', color: '#8A6338' }}
              >
                AI-Powered Astrology
              </span>
            </div>

            <h1
              className="font-serif font-light tracking-[-0.02em] mb-4 sm:mb-6 flex-shrink-0"
              style={{ fontSize: 'clamp(1.6rem, 4.5vw, 4.2rem)', lineHeight: '1.08', color: '#2B2017' }}
            >
              Get Answers. Not Assumptions. <br/>
              Powered by AI.
            </h1>

            <p
              className="leading-relaxed mb-6 sm:mb-10 max-w-md flex-shrink-0"
              style={{ fontSize: 'clamp(0.82rem, 1vw, 1.05rem)', color: '#5A4636' }}
            >
              Astrology, Palmistry and Tarot — combined into one AI-powered reading.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-8 sm:mb-12 lg:mb-14 flex-shrink-0">
              <button
                onClick={() => navigate('/horoscope')}
                className="w-full sm:w-auto px-7 py-3 sm:py-3.5 font-semibold tracking-[0.08em] uppercase transition-all duration-300 hover:-translate-y-px hover:shadow-lg active:translate-y-0"
                style={{ fontSize: 'clamp(0.75rem, 0.85vw, 0.88rem)', background: '#8A6338', color: '#F5EDE1', borderRadius: '8px' }}
              >
                Start Your Reading
              </button>
              <button
                onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full sm:w-auto px-7 py-3 sm:py-3.5 font-medium tracking-[0.08em] uppercase transition-all duration-300 hover:-translate-y-px active:translate-y-0"
                style={{ fontSize: 'clamp(0.75rem, 0.85vw, 0.88rem)', color: '#8A6338', background: 'transparent', borderRadius: '8px' }}
              >
                See How It Works
              </button>
            </div>

            <div className="grid grid-cols-4 gap-3 sm:gap-6 pt-5 flex-shrink-0" style={{ borderTop: '1px solid #A98C6B' }}>
              {STATS.map((stat, i) => (
                <div key={i}>
                  <span className="font-serif font-light leading-none block golden-text mb-1" style={{ fontSize: 'clamp(1.1rem, 2vw, 1.8rem)' }}>
                    {stat.value}
                  </span>
                  <span className="font-mono uppercase block tracking-[0.1em]" style={{ fontSize: 'clamp(5.5px, 0.6vw, 7px)', color: '#8A7A6A', lineHeight: '1.3' }}>
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[50%] xl:w-[52%] flex-shrink-0">
            <div
              className="relative w-full overflow-hidden h-[180px] sm:h-[220px] lg:h-[clamp(280px,60vh,640px)]"
              style={{ borderRadius: '12px', border: '1px solid #A98C6B' }}
            >
              <img
                src="/images/assets/img1.jpg"
                alt="Editorial photograph"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroPanel
